import { Injectable, inject } from '@angular/core'
import { AccountObject, DistributionListObject } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ModalService } from 'src/shared/modal/modal.service'
import { DistributionListOverlayComponent, DistributionListOverlayOptions } from './distribution-list-overlay.component'

@Injectable()
export class DistributionListOverlayService {
  private modal = inject(ModalService)


  showCreateDistributionList(company: DeepReadonly<AccountObject>) {
    return this.modal.openDialog<DistributionListOverlayComponent, DistributionListOverlayOptions>(
      DistributionListOverlayComponent,
      {
        company,
      },
      {
        panelClass: ['tc-dialog', 'modal-lg'],
        width: null,
        maxWidth: null,
        autoFocus: false,
        disableClose: false,
      },
    )
  }

  showUpdateDistributionList(company: DeepReadonly<AccountObject>, distributionList: DeepReadonly<DistributionListObject>) {
    return this.modal.openDialog<DistributionListOverlayComponent, DistributionListOverlayOptions>(
      DistributionListOverlayComponent,
      {
        company,
        distributionList,
      },
      {
        panelClass: ['tc-dialog', 'modal-lg'],
        width: null,
        maxWidth: null,
        autoFocus: false,
        disableClose: false,
      },
    )
  }
}
